export function isEnabled(org, feature) {
  if (org && org.featureGates) {
    try {
      const orgFeatures = JSON.parse(org.featureGates);
      return orgFeatures[feature] === 'enabled';
    } catch (err) {
      return false;
    }
  }
  return false;
}

export function isDisabled(org, feature) {
  if (org && org.featureGates) {
    try {
      const orgFeatures = JSON.parse(org.featureGates);
      return orgFeatures[feature] === 'disabled';
    } catch (err) {
      return false;
    }
  }
  return false;
}

export const FEATURES_FLAGS = Object.freeze({
  CONTRACT_UI_ENABLED: 'contractUIEnabled'
});
